export class BillingData {
	public id: number
	public officialCompanyName: string | null
	public tax: string | null
	public notificationEmails: string[]
	public invoiceAutomatically: boolean
	public sendInvoiceAutomatically: boolean
	public taxId: number | null
	public billingSystemId: number | null
	public invoiceIntegrationId: number | null
	public chargeAutomatically: boolean
	public country: string | null
	public state: string | null
	public city: string | null
	public street: string | null
	public zip: string | null

	constructor(data: {
		id: number
		officialCompanyName: string | null
		tax: string | null
		notificationEmails: string[]
		invoiceAutomatically: boolean
		sendInvoiceAutomatically: boolean
		taxId: number | null
		billingSystemId: number | null
		invoiceIntegrationId: number | null
		chargeAutomatically: boolean
		country: string | null
		state: string | null
		city: string | null
		street: string | null
		zip: string | null
	}) {
		this.id = data.id
		this.officialCompanyName = data.officialCompanyName
		this.tax = data.tax
		this.notificationEmails = data.notificationEmails
		this.invoiceAutomatically = data.invoiceAutomatically
		this.sendInvoiceAutomatically = data.sendInvoiceAutomatically
		this.taxId = data.taxId
		this.billingSystemId = data.billingSystemId
		this.invoiceIntegrationId = data.invoiceIntegrationId
		this.chargeAutomatically = data.chargeAutomatically
		this.country = data.country
		this.state = data.state
		this.city = data.city
		this.street = data.street
		this.zip = data.zip
	}

	static create(data: Partial<BillingData>): BillingData {
		const defaultData: BillingData = {
			id: 0,
			officialCompanyName: null,
			tax: null,
			notificationEmails: [],
			invoiceAutomatically: false,
			sendInvoiceAutomatically: false,
			taxId: null,
			billingSystemId: null,
			invoiceIntegrationId: null,
			chargeAutomatically: false,
			country: null,
			state: null,
			city: null,
			street: null,
			zip: null,
		}

		return new BillingData({ ...defaultData, ...data })
	}
}
